<div class="pt-2"></div>

<div class="row">
    <div class="col-12">
        <h3 class="content__header">Dashboard</h3>
    </div>
</div>

<div class="row g-3">
    <div class="col-md">
        <app-notifications
            class="card mb-3"
            [notifications]="activeNotification$ | async"
        ></app-notifications>
    </div>
    <div class="col-md">
        <app-recentclients
            class="card mb-3"
            [recentClients]="recentClients$ | async"
            (selectClient)="selectClient($event)"
        ></app-recentclients>
    </div>
    <div class="col-md">
        <app-birthdays
            class="card mb-3"
            [birthDays]="birthdays$ | async"
            (selectClient)="selectClient($event)"
            (allBirthdays)="allBirthdays()"
        ></app-birthdays>
    </div>
</div>
